import {
  Flex,
  Box,
  Text,
  CircularProgress,
  CircularProgressLabel,
  Spinner,
} from "@chakra-ui/react";
import HeaderMenu from "./components/HeaderMenu";
import MenuUser from "./components/MenuUser";
import { StyledHeader } from "./components/styles";
import logo from "assets/images/svgs/logo.svg";
import { Image } from "@chakra-ui/react";
import { useCurrentAuth } from "features/auth/auth.store";
import { useCurrentTenant } from "features/auth/tenant.store";
import { Menu } from "features/menu/typings/menu";
import { useMenu } from "core/features/menu";
import { useCallback, useMemo, useState } from "react";
import { useWindowSize } from "infra/helpers/window";
import ResponsiveMenu from "./components/ResponsiveMenu";
import colors from "core/resources/theme/colors";
import PrimaryButton from "components/Button/PrimaryButton";
import { ModalCadastroIncompleto } from "./components/ModalCadastroIncompleto";
import { TenantPassoCadastroResponse } from "./typings/header.data";
import Container from "components/Container";
import history from "infra/helpers/history";

interface HeaderProps {
  porcentagemConcluidaPassosCadastro?: number;
  passos?: TenantPassoCadastroResponse;
  isLoadingPassos?: boolean;
  isFetchingPassos?: boolean;
}

function Header({
  porcentagemConcluidaPassosCadastro = 0,
  passos = [],
  isLoadingPassos,
  isFetchingPassos,
}: HeaderProps) {
  const { menu } = useMenu();
  const [isOpenModal, setIsOpenModal] = useState(false);

  const { auth } = useCurrentAuth();
  const { tenant } = useCurrentTenant();

  const checkVisible = useCallback(
    (menus: Menu[]) => {
      return menus.filter((item) => {
        const possuiAcesso = item.visible(tenant, auth);

        return possuiAcesso;
      });
    },
    [auth, tenant]
  );

  const menus = useMemo(() => {
    const result: Menu[] = [];
    for (const item of checkVisible([...menu(tenant)])) {
      for (const submenu of item.children) {
        submenu.children = checkVisible(submenu.children);
      }

      item.children = checkVisible(item.children);

      result.push(item);
    }

    return result;
  }, [menu, tenant, checkVisible]);

  const windowSize = useWindowSize();

  const isDesktop = windowSize.width > 992;
  const isMobile = windowSize.width <= 992;

  const hiddenPassos =
    !passos.length ||
    porcentagemConcluidaPassosCadastro === 100 ||
    isLoadingPassos;

  return (
    <StyledHeader className="hidden-print" width={windowSize.width}>
      {!hiddenPassos ? (
        <>
          <Flex
            bg={colors.red1000}
            h={14}
            align="center"
            justifyContent="center"
            gap={6}
          >
            {isFetchingPassos ? (
              <Spinner size="md" color="primary" />
            ) : (
              <CircularProgress
                value={porcentagemConcluidaPassosCadastro ?? 0}
                color="green.400"
              >
                <CircularProgressLabel>
                  {porcentagemConcluidaPassosCadastro ?? 0}%
                </CircularProgressLabel>
              </CircularProgress>
            )}
            <Text fontWeight="bold">
              Complete seu cadastro e tenha acesso total ao sistema!
            </Text>
            <PrimaryButton h={4} onClick={() => setIsOpenModal(true)}>
              {" "}
              Completar
            </PrimaryButton>
          </Flex>

          <ModalCadastroIncompleto
            isOpen={isOpenModal}
            data={passos}
            onClose={() => setIsOpenModal(false)}
          />
        </>
      ) : null}

      <Container>
        <Flex flex="1">
          <Flex flex={isMobile ? 1 : undefined} alignItems="center">
            <Image
              onClick={() => history.push("/")}
              cursor="pointer"
              className="logo"
              w={"150px"}
              src={logo}
            />
          </Flex>

          {isDesktop ? (
            <Flex flex="1" justifyContent="center">
              <Box>
                <HeaderMenu menus={menus} />
              </Box>
            </Flex>
          ) : null}
          {isDesktop ? (
            <Flex>
              <MenuUser />
            </Flex>
          ) : null}

          {isMobile ? <ResponsiveMenu items={menus} /> : null}
        </Flex>
      </Container>
    </StyledHeader>
  );
}

export default Header;
